module.exports = __webpack_public_path__ + "img/visualisierung small inside.dcb252ef.jpg";